export enum PaymentMethodEnum {
  TYPE_PBL = 'pbl',
  TYPE_BLIK = 'blik',
  TYPE_CARD = 'card',
  TYPE_GPAY = 'gpay',
  TYPE_APAY = 'apay',
  TYPE_CTX = 'cinkciarz',
}
